module.exports = __webpack_public_path__ + "media/images/chats/the-president-has-runaway.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/chats/the-president-has-runaway.jpg
// module id = 80
// module chunks = 0